'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of three supp bottles
 */ const ThreeSuppBottles = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 105",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52.9492",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M43.617 40.0642V36.0871C45.1984 36.0871 46.4803 34.8052 46.4803 33.2238V32.3229C46.4803 30.2439 44.795 28.5586 42.7161 28.5586H24.0041C21.9252 28.5586 20.2398 30.2439 20.2398 32.3229V33.2238C20.2398 34.8052 21.5218 36.0871 23.1032 36.0871V40.1229C21.532 40.6968 20.1771 41.729 19.2202 43.081C18.2633 44.4331 17.7503 46.0403 17.75 47.6869V72.5102C17.75 74.6441 19.4799 76.374 21.6138 76.374H45.2795C47.4134 76.374 49.1432 74.6441 49.1432 72.5102V47.6906C49.1432 46.0129 48.6109 44.3768 47.6205 43.01C46.6301 41.6432 45.2307 40.6136 43.617 40.0642Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "19.9805",
                y: "28.5664",
                width: "26.4992",
                height: "7.53755",
                rx: "1.11005",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M80.7459 40.0642V36.0871C82.3273 36.0871 83.6092 34.8052 83.6092 33.2238V32.3229C83.6092 30.2439 81.9239 28.5586 79.845 28.5586H61.133C59.0541 28.5586 57.3688 30.2439 57.3688 32.3229V33.2238C57.3688 34.8052 58.6507 36.0871 60.2321 36.0871V40.1229C58.6609 40.6968 57.306 41.729 56.3491 43.081C55.3922 44.4331 54.8792 46.0403 54.8789 47.6869V72.5102C54.8789 74.6441 56.6088 76.374 58.7427 76.374H82.4084C84.5423 76.374 86.2721 74.6441 86.2721 72.5102V47.6906C86.2721 46.0129 85.7398 44.3768 84.7494 43.01C83.759 41.6432 82.3596 40.6136 80.7459 40.0642Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "57.1055",
                y: "28.5664",
                width: "26.4992",
                height: "7.53755",
                rx: "1.11005",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M63.9312 37.9386V33.1523C65.8344 33.1523 67.3772 31.6095 67.3772 29.7063V27.9556C67.3772 25.8217 65.6473 24.0918 63.5134 24.0918H39.661C37.5271 24.0918 35.7973 25.8217 35.7973 27.9556V29.7063C35.7973 31.6095 37.3401 33.1523 39.2432 33.1523V38.0092C37.3523 38.6999 35.7217 39.9421 34.5701 41.5692C33.4186 43.1964 32.8012 45.1306 32.8008 47.1124V77.7729C32.8008 79.9068 34.5307 81.6367 36.6646 81.6367H66.7181C68.852 81.6367 70.5819 79.9068 70.5819 77.7729V47.1168C70.5819 45.0977 69.9413 43.1288 68.7494 41.4838C67.5574 39.8389 65.8733 38.5997 63.9312 37.9386Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "35.4844",
                y: "24.0859",
                width: "31.8913",
                height: "9.0713",
                rx: "1.11005",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("ellipse", {
                cx: "70.5332",
                cy: "67.0225",
                rx: "9.334",
                ry: "7.51273",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M70.6593 54.2715C63.8114 54.2715 58.2383 59.8446 58.2383 66.6925C58.2383 73.5405 63.8114 79.1136 70.6593 79.1136C77.5073 79.1136 83.0804 73.5405 83.0804 66.6925C83.0804 59.8446 77.5073 54.2715 70.6593 54.2715ZM77.2045 64.8417L70.5114 72.3111C70.1562 72.705 69.6508 72.9349 69.1204 72.9349C68.5899 72.9349 68.0822 72.7073 67.7294 72.3111L63.907 68.0471C63.2194 67.2776 63.2832 66.0938 64.0527 65.4085C64.3964 65.1035 64.8381 64.9305 65.298 64.9305C65.8284 64.9305 66.3384 65.1581 66.6912 65.5542L69.1204 68.2657L74.4225 62.3488C74.7777 61.955 75.2854 61.7273 75.8135 61.7273C76.2757 61.7273 76.7173 61.898 77.0611 62.2054C77.4344 62.5378 77.653 62.9976 77.6803 63.4962C77.7076 63.9925 77.5392 64.4729 77.2045 64.8439V64.8417Z",
                fill: theme.ds5.asset[assetColor]["500"]
            })
        ]
    });
};

exports.ThreeSuppBottles = ThreeSuppBottles;
//# sourceMappingURL=ThreeSuppBottles.cjs.map
